export default __webpack_public_path__ + "static/media/Model Y.763bc4de.png";